import { Box } from '~/commonComponents';
import { Tab, TabList, Tabs } from '~/commonComponents/Tabs';
import { Colors } from '~/themes/colors';
import { CandidateStatus } from '../../utils';

const TitleCopy = {
  [CandidateStatus.Hired]: 'Hired',
  [CandidateStatus.Interviewed]: 'Interviewed',
  [CandidateStatus.New]: 'New',
  [CandidateStatus.Rejected]: 'Rejected',
  [CandidateStatus.Scheduled]: 'Scheduled',
};

const DotColors = {
  [CandidateStatus.Hired]: Colors.success_500,
  [CandidateStatus.Interviewed]: Colors.neutral_400,
  [CandidateStatus.New]: Colors.primary_500,
  [CandidateStatus.Rejected]: Colors.error_450,
  [CandidateStatus.Scheduled]: Colors.secondary_600,
};

interface ICandidateStatusFilterPanelProps {
  counts: Record<CandidateStatus, number>;
  onChange(tab: CandidateStatus | 'all'): void;
}

export const CandidateStatusFilterPanel = ({
  counts,
  onChange,
}: ICandidateStatusFilterPanelProps) => {
  const tabs = [
    CandidateStatus.New,
    CandidateStatus.Scheduled,
    CandidateStatus.Interviewed,
    CandidateStatus.Rejected,
    CandidateStatus.Hired,
  ];
  const totalCount = Object.values(counts).reduce((sum, count) => sum + count, 0);

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx - 1] || 'all');
  };

  return (
    // @ts-expect-error JS Component
    <Tabs tabListStyle={{ gap: 16 }} onChangeTab={handleTabChange}>
      {/* @ts-expect-error JS Component */}
      <TabList>
        {/* @ts-expect-error JS Component */}
        <Tab
          title={`All${totalCount > 0 ? ` (${totalCount})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {tabs.map((it) => (
          // @ts-expect-error JS Component
          <Tab
            PrefixComponent={
              <Box backgroundColor={DotColors[it]} borderRadius="100%" height={10} width={10} />
            }
            key={it}
            title={`${TitleCopy[it]}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
